import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueSweetalert2 from 'vue-sweetalert2'
import VueApexCharts from 'vue-apexcharts'
import router from './router/index'
import store from '@/vuex/store'
import vco from 'v-click-outside'
import Sparkline from 'vue-sparklines';
import Cookies from 'js-cookie'
import axios from 'axios';
import money from 'v-money'
import VueI18n from 'vue-i18n'
import '@/design/index.scss';
import '@/utilities/filters';
import '@/utilities/mixins';
import '@/directives/chat-scroll';
import '@/directives/on-scroll';
import english from '@/lang/en';
import indonesia from '@/lang/id';

Vue.use(BootstrapVue);

Vue.config.productionTip = false

// register directive v-money and component <money>
Vue.use(money)

Vue.use(Vuelidate);
Vue.use(VueMask)
Vue.use(VueSweetalert2)
Vue.use(require('vue-chartist'))
Vue.use(vco)
Vue.use(Sparkline)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
Vue.component('VueSlickCarousel', VueSlickCarousel)

// setup locale
if (Cookies.get("locale") === undefined) {
  store.commit("SET_LOCALE", 'id');
  Cookies.set("locale", 'id', { expires: 1 });
} else {
  const defaultLocale = Cookies.get("locale");
  store.commit("SET_LOCALE", defaultLocale);
}

// setup i18n
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: store.getters.locale, // set locale
  messages: {
    en: english,
    id: indonesia
  } // set locale messages
});

let axiosOptoins = {
  baseURL: process.env.VUE_APP_BASE_URL_API,
  timeout: 180000, // 3 menit
  headers: {
    'X-timezone': 'Asia/Jakarta',
    'Accept': 'application/json',
    'X-lang': store.getters.locale
  }
}
if (Cookies.get('userdata') !== undefined) {
  const auth = JSON.parse(Cookies.get('userdata'))
  store.commit('SET_LOGIN', auth) 
  axiosOptoins.headers.Authorization = 'Bearer ' + auth.key.token
}
Vue.prototype.$axios = axios.create(axiosOptoins);


// Import the functions you need from the SDKs you need
import firebase from "firebase/app";
import "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// Initialize Firebase
const app = firebase.initializeApp({
  apiKey: "AIzaSyCgmicXZ4zl3r7Pm1ZRa80ct2n7YX41w9Q",
  authDomain: "etruck-aex.firebaseapp.com",
  projectId: "etruck-aex",
  storageBucket: "etruck-aex.appspot.com",
  messagingSenderId: "922724984039",
  appId: "1:922724984039:web:6363b7c0f3e762463d2e42",
  measurementId: "G-NXZHBHEWF1"
});
Vue.prototype.$firebase = app;

navigator.serviceWorker
  .register("firebase-messaging-sw.js")
  .then((registration) => {
    const messaging = app.messaging();
    messaging.useServiceWorker(registration);
  })
  .catch((err) => {
    console.log(err);
  });
// fiebase configs end

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
